module.exports = __webpack_public_path__ + "static/media/37.2ac145d2.png";